import './infoBlock.css'
import { PropsWithChildren } from 'react'

export const InfoBlockWrap = ({ children }: PropsWithChildren) => {
  return <div className="info-block-wrap">{children}</div>
}
